import(/* webpackMode: "eager", webpackExports: ["ProductShell"] */ "/app/components/layout/product-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OnboardingPageClient"] */ "/app/components/onboarding/onboarding-page-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
